export var leftQuoteIconPlacement = 'ro9zL';
export var textureMetalBackground = '_71qsq';